import React from "react";
import classNames from "classnames";
import { Button } from "~/core";
import "./field-information-button-bar.css";

interface IProps {
    saveIsEnabled: boolean;
    onSave: () => void;
    onCancel: () => void;
}

export const FieldInformationButtonBar = (props: IProps): JSX.Element => {
    /// Event Handlers ///

    /// ------------- ///

    return (
        <div className={classNames("information-button-bar", "field-information-button-bar")}>
            <Button
                type="save"
                disabled={!props.saveIsEnabled}
                onClick={() => {
                    props.onSave();
                }}
                testId="field-info-save-button"
            />
            <Button
                type="cancel"
                onClick={() => {
                    props.onCancel();
                }}
                testId="field-info-cancel-button"
            />
        </div>
    );
};
FieldInformationButtonBar.defaultProps = {};
